import React from 'react';

const AsyncLoader = () => <p style={{ display: 'none' }}>Loading component...</p>;

export default AsyncLoader;
